import { useCallback } from 'react';
import { useActions } from '../provider/actions';
import { useModalActions } from '../provider/modalManager';
import { useValueRef } from '../../../hooks/useValueRef';

export const useLinkClickHandler = ({ initialData, modalName }) => {
  const initialDataRef = useValueRef(initialData);

  const { getEditorState } = useActions();
  const { open } = useModalActions();

  return useCallback(() => {
    let data = { ...initialDataRef.current };
    const state = getEditorState();
    const selection = state.getSelection();

    if (!selection.isCollapsed()) {
      const selectedText = state
        .getCurrentContent()
        .getBlockForKey(selection.getAnchorKey())
        .getText()
        .slice(selection.getStartOffset(), selection.getEndOffset());

      data.text = selectedText;
    }

    open(modalName, data);
  }, [initialDataRef, modalName, getEditorState, open]);
};
